import React from "react";

function Icons() {
  return (
    <div className="media-icons">
      <ul className="unorder">
        <li className="listed">
          <a href="https://github.com/Ayush-Kmr" target="blank">
            <i className="fab fa-github icon"></i>
          </a>
        </li>
        <li className="listed">
          <a href="https://twitter.com/Ayu_kmr" target="blank">
            <i className="fab fa-x-twitter icon"></i>
          </a>
        </li>
        <li className="listed">
          <a href="https://www.linkedin.com/in/ayu-kmr/" target="blank">
            <i className="fab fa-linkedin-in icon"></i>
          </a>
        </li>
        <li className="listed">
          <a href="https://www.instagram.com/ayu.kmr/" target="blank">
            <i className="fab fa-instagram icon"></i>
          </a>
        </li>
        <li className="listed">
          <a href="mailto:krayuskumar01@gmail.com" target="blank">
            <i className="fab fa-google icon"></i>
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Icons;
